// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import SettingsStoragePage from './SettingsStoragePage';

export default SettingsStoragePage;
